module.exports = __webpack_public_path__ + "img/score_C.34a195c5.png";